module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter9"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch9"
    }
  }, [_vm._v("Butternut Squash Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Butternut squash, that rather shapely but not-too-attractive squash, becomes the star of the slow cooker in this delicious soup. The slow cooker takes the rock- hard squash and cooks it to almost a purée. If you would like a smoother soup, a run around the cooker with your immersion blender is all that it takes. Try garnishing this soup with one of your favorites: lump crabmeat, crumbled goat cheese, or croutons. It can be served immediately, or cooled and refrigerated for up to 4 days, or frozen for up to 6 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 tablespoons (½ stick) unsalted butter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 cup finely chopped sweet onion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup finely chopped carrot")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup finely chopped celery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 cups 1-inch pieces peeled and seeded butternut squash")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cups chicken or vegetable broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("melt the butter in a large skillet over medium-high heat. Add the onion, carrot, celery, and thyme and sauté until the vegetables are softened, 3 to 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Add the squash and broth, and season with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover the slow cooker and cook on high for 3 hours or on low for 6 hours. At the end of the cooking time, stir the soup and season with salt and pepper. If you would like to purée the soup, use an immersion blender, or cool the soup and purée it in a blender.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serve warm from the cooker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-853bdb52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/015-chapter9.vue
// module id = 99
// module chunks = 0